/*
 * animations-config.js — GSAP defaults for the theme animations (golf 2, 21-10-2026).
 * Was an inline <script> directly after animations.min.js at the end of <body>.
 * Moved to an asset so animations.min.js can load with `defer`; this file is the next
 * deferred script, so it still runs right after GSAP and before slideshow.js / app.js.
 * Same three statements as before, guarded in case the animations setting is off.
 */
if (window.gsap) {
  gsap.defaults({
    ease: Power4.easeOut
  });
  gsap.config({
    nullTargetWarn: false
  });
  gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin);
}
